import intlMessageEN from '../components/il8n/locales/en.json';
import intlMessageES from '../components/il8n/locales/es.json';
import intlMessageFR from '../components/il8n/locales/fr.json';
import intlMessageIT from '../components/il8n/locales/it.json';
import intlMessageJP from '../components/il8n/locales/ja.json';
import intlMessageDE from '../components/il8n/locales/de.json';
import intlMessageAR from '../components/il8n/locales/ar.json';
import intlMessageTR from '../components/il8n/locales/tr.json';

import {ar, de, enUS, es, fr, it, ja, tr} from 'date-fns/locale';
import {getLocaleFromParent} from "./ParentDataHandler";
import {STRINGS} from "../commons/constants/CommonConstants";

export async function getLocale() {
    const locale = await fetchLocale();
    switch (locale.toString()) {
        case "de":
        case "de-DE":
        case "de-CH":
        case "de-AT":
        case "de-LU":
        case "de-LI":
            return "de"
        case "es":
        case "es-ES":
        case "es-AR":
        case "es-GT":
        case "es-CR":
        case "es-PA":
        case "es-DO":
        case "es-MX":
        case "es-VE":
        case "es-CO":
        case "es-PE":
        case "es-EC":
        case "es-CL":
        case "es-UY":
        case "es-PY":
        case "es-BO":
        case "es-SV":
        case "es-HN":
        case "es-NI":
        case "es-PR":
            return "es"
        case "ja":
        case "ja-JP":
            return "ja"
        case "it":
        case "it-IT":
        case "it-CH":
            return "it"
        case "fr":
        case "fr-FR":
        case "fr-BE":
        case "fr-CA":
        case "fr-CH":
        case "fr-LU":
            return "fr"
        case "ar":
        case "ar-SA":
        case "ar-IQ":
        case "ar-EG":
        case "ar-LY":
        case "ar-DZ":
        case "ar-MA":
        case "ar-TN":
        case "ar-OM":
        case "ar-YE":
        case "ar-SY":
        case "ar-JO":
        case "ar-LB":
        case "ar-KW":
        case "ar-AE":
        case "ar-BH":
        case "ar-QA":
            return "ar"
        case "tr":
        case "tr-TR":
            return "tr"
        default:
            return "en"
    }
}

export async function fetchLocale() {
    const localeResponse = await getLocaleFromParent();
    if (STRINGS.TIMEOUT === localeResponse) {
        /*
         * Fallback when time out
         */
        return navigator.language;
    }
    const locale = JSON.parse(localeResponse.locale);
    if (STRINGS.EMPTY === locale) {
        /*
         * Fallback when backend return empty locale, happens for MLS disabled regions https://weblab.amazon.com/wl/SCC_MLS_349230
         */
        return navigator.language;
    }
    return locale;
}

export function getDirection(locale) {
    return locale === "ar" ? "rtl" : "ltr";
}

export function getDateLocale() {
    getLocale().then(locale => {
            switch (locale) {
                case "en":
                    return enUS
                case "es":
                    return es
                case "fr":
                    return fr
                case "it":
                    return it
                case "ja":
                    return ja
                case "de":
                    return de
                case "ar":
                    return ar
                case "tr":
                    return tr
                default:
                    return enUS
            }
        }
    )
}

export function getMessages(locale) {
    switch (locale) {
        case "en":
            return intlMessageEN
        case "es":
            return intlMessageES
        case "fr":
            return intlMessageFR
        case "it":
            return intlMessageIT
        case "ja":
            return intlMessageJP
        case "de":
            return intlMessageDE
        case "ar":
            return intlMessageAR
        case "tr":
            return intlMessageTR
        default:
            return intlMessageEN
    }
}


// WEBPACK FOOTER //
// ./src/handler/LocaleHandler.js